import { map } from 'lodash'
import moment from 'moment'

const prepareSave = access => {
  access.go_in = access.go_in
  return access
}

const prepareShow = access => {
  access.go_in = moment(access.go_in, 'YYYYMMDD').format('DD/MM/YYYY')
  return access
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Acesso incluido com sucesso.')
    return this.$router.push({name: 'dweller.access.index'})
  },
  afterUpdated () {
    this.$toast.success('Acesso alterado com sucesso.')
    return this.$router.push({name: 'dweller.access.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }
  },
  getGaragesDweller (unit) {
    if (typeof unit === 'object') {
      const search = {
        unit_id: unit.id,
        tower_id: this.access.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: this.access.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getGaragesDwellerEdit (unit, tower) {
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: tower
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/form/resources/methods.js